var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iframeUrl)?_c('div',{staticClass:"admin-next-iframe-container",class:_vm.fullView ? 'admin-next-iframe-container--full' : 'admin-next-iframe-container--inline'},[_c('iframe',{ref:"iframe",staticClass:"admin-next-iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0","allow":_vm.allow,"allowfullscreen":""}})]):_c('div',[_vm._t("fallback")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }